import React from "react";
import { Rocket } from "lucide-react";
import { APP } from "@/config";

export const Logo = ({ className = "", showText = true, size = "md" }) => {
  const box = size === "sm" ? "h-8 w-8" : "h-9 w-9";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <div className={`${box} rounded-xl bg-gradient-to-br from-brand-500 to-brand-700 flex items-center justify-center shadow-lg shadow-brand-500/25`}>
        <Rocket className="h-5 w-5 text-white" strokeWidth={2.4} />
      </div>
      {showText && <span className="font-display font-extrabold text-lg tracking-tight">{APP.name}</span>}
    </div>
  );
};
